<div
  #hostRoot
  class="event-playback-host"
  [class.event-playback-host--minimal]="mode() === 'playback' && !useLibraryTimeline()"
  [class.event-playback-host--live]="mode() === 'live'"
  [class.event-playback-host--fullscreen]="isFullscreen()"
  [class.event-playback-host--library-timeline]="useLibraryTimeline()"
  [class.event-playback-host--video-contain]="videoObjectFit() === 'contain'"
  [class.event-playback-host--video-cover]="videoObjectFit() === 'cover'"
>
  <header class="event-playback-host__header">
    <div class="event-playback-host__title-row">
      <span class="event-playback-host__title">{{ headerTitle() }}</span>
      @if (useLibraryTimeline()) {
        <span
          class="event-playback-host__online-badge"
          role="status"
          aria-live="polite"
          [attr.aria-label]="streamStatusLabel()"
          >{{ streamStatusLabel() }}</span
        >
      } @else if (mode() === 'playback' && headerTimestamp()) {
        <span class="event-playback-host__timestamp">{{ headerTimestamp() }}</span>
      }
      @if (mode() === 'live') {
        <eventq-badge variant="live" />
      }
    </div>

    @if (mode() === 'playback') {
      @if (allowClipToggle() && !useLibraryTimeline()) {
        <button
          type="button"
          class="event-playback-host__view-toggle event-playback-host__view-toggle--playback"
          [attr.aria-label]="
            'Switch to ' + (effectivePlaybackViewMode() === 'clip' ? 'playback' : 'clip') + ' view'
          "
          [attr.aria-pressed]="effectivePlaybackViewMode() === 'playback'"
          (click)="onTogglePlaybackViewMode()"
        >
          {{ viewModeLabel() }}
        </button>
      }
      <div class="event-playback-host__actions event-playback-host__actions--playback">
        @if (snapshotEnabled()) {
          <button
            type="button"
            class="event-playback-host__icon-btn event-playback-host__icon-btn--24"
            aria-label="Take snapshot"
            [disabled]="submittingSnapshot()"
            (click)="onSnapshotClick()"
          >
            <span class="event-playback-host__icon-glyph event-playback-host__icon-glyph--snapshot">
              <img [src]="'assets/library-icons/snapshot-glyph.svg' | prefixUrl" alt="" />
            </span>
          </button>
        }
        @if (showAttachAlarmClip()) {
          <button
            type="button"
            class="event-playback-host__icon-btn event-playback-host__icon-btn--24"
            aria-label="Attach alarm clip"
            [disabled]="submittingAttachAlarmClip()"
            (click)="onAttachAlarmClipClick($event)"
          >
            <span class="event-playback-host__icon-glyph event-playback-host__icon-glyph--attach-clip">
              <img [src]="'assets/library-icons/add-video-clip-glyph.svg' | prefixUrl" alt="" />
            </span>
          </button>
        }
        @if (showFullscreenAction()) {
          <button
            type="button"
            class="event-playback-host__icon-btn event-playback-host__icon-btn--32"
            [attr.aria-label]="isFullscreen() ? 'Exit fullscreen' : 'Enter fullscreen'"
            (click)="onToggleFullscreen()"
          >
            <span
              class="event-playback-host__icon-glyph"
              [class.event-playback-host__icon-glyph--fullscreen]="!isFullscreen()"
              [class.event-playback-host__icon-glyph--exit-fullscreen]="isFullscreen()"
            >
              <img
                [src]="
                  isFullscreen()
                    ? ('assets/library-icons/exit-fullscreen-glyph.svg' | prefixUrl)
                    : ('assets/library-icons/fullscreen-glyph.svg' | prefixUrl)
                "
                alt=""
              />
            </span>
          </button>
        }
      </div>
    } @else {
      <div class="event-playback-host__actions event-playback-host__actions--live">
        @if (showPtzToggle()) {
          <button
            type="button"
            class="event-playback-host__view-toggle event-playback-host__view-toggle--stream"
            [class.event-playback-host__view-toggle--active]="ptzControlsOpen()"
            aria-label="Toggle PTZ controls"
            [attr.aria-pressed]="ptzControlsOpen()"
            (click)="onTogglePtzControls()"
          >
            PTZ
          </button>
        }
        <button
          type="button"
          class="event-playback-host__view-toggle event-playback-host__view-toggle--hd"
          aria-label="HD stream"
          [attr.aria-pressed]="streamType() === 'main' ? 'true' : 'false'"
          (click)="onToggleStreamType()"
        >
          HD
          <span
            class="event-playback-host__hd-indicator"
            [class.event-playback-host__hd-indicator--on]="streamType() === 'main'"
          ></span>
        </button>
        <div class="event-playback-host__flag-action">
          <button
            #flagTrigger
            type="button"
            class="event-playback-host__icon-btn event-playback-host__icon-btn--24"
            [class.event-playback-host__icon-btn--active]="flagReportOpen()"
            aria-label="Flag camera"
            (click)="onFlagClick()"
          >
            <span class="event-playback-host__icon-glyph event-playback-host__icon-glyph--flag">
              <img [src]="'assets/library-icons/flag-glyph.svg' | prefixUrl" alt="" />
            </span>
          </button>

          @if (flagReportOpen()) {
            <eventq-flag-report-popover
              [open]="true"
              [selectedReasonId]="selectedReportReasonId()"
              [submitDisabled]="submittingReport()"
              [anchor]="flagTrigger"
              panelWidth="396px"
              (closed)="onFlagReportClose()"
              (selectedReasonIdChange)="onFlagReportReasonSelect($event)"
              (confirm)="onFlagReportConfirm($event)"
            />
          }
        </div>
        @if (snapshotEnabled()) {
          <button
            type="button"
            class="event-playback-host__icon-btn event-playback-host__icon-btn--24"
            aria-label="Take snapshot"
            [disabled]="submittingSnapshot()"
            (click)="onSnapshotClick()"
          >
            <span class="event-playback-host__icon-glyph event-playback-host__icon-glyph--snapshot">
              <img [src]="'assets/library-icons/snapshot-glyph.svg' | prefixUrl" alt="" />
            </span>
          </button>
        }
        @if (showAttachAlarmClip()) {
          <button
            type="button"
            class="event-playback-host__icon-btn event-playback-host__icon-btn--24"
            aria-label="Attach alarm clip"
            [disabled]="submittingAttachAlarmClip()"
            (click)="onAttachAlarmClipClick($event)"
          >
            <span class="event-playback-host__icon-glyph event-playback-host__icon-glyph--attach-clip">
              <img [src]="'assets/library-icons/add-video-clip-glyph.svg' | prefixUrl" alt="" />
            </span>
          </button>
        }
        <button
          type="button"
          class="event-playback-host__icon-btn event-playback-host__icon-btn--32"
          [attr.aria-label]="isFullscreen() ? 'Exit fullscreen' : 'Enter fullscreen'"
          (click)="onToggleFullscreen()"
        >
          <span
            class="event-playback-host__icon-glyph"
            [class.event-playback-host__icon-glyph--fullscreen]="!isFullscreen()"
            [class.event-playback-host__icon-glyph--exit-fullscreen]="isFullscreen()"
          >
            <img
              [src]="
                isFullscreen()
                  ? ('assets/library-icons/exit-fullscreen-glyph.svg' | prefixUrl)
                  : ('assets/library-icons/fullscreen-glyph.svg' | prefixUrl)
              "
              alt=""
            />
          </span>
        </button>
      </div>
    }
  </header>

  <div class="event-playback-host__stage-wrap" #stageWrap>
    @if (showAlarmClipUnavailable()) {
      <div
        class="event-playback-host__clip-unavailable"
        role="status"
        aria-live="polite"
      >
        <img
          class="event-playback-host__stream-loader-emblem"
          [src]="'assets/events/ecam-emblem.svg' | prefixUrl"
          alt=""
        />
        <span class="event-playback-host__clip-unavailable-label">Alarm clip is unavailable</span>
      </div>
    } @else if (usesAlarmImageClip() && activeAlarmClipFrameUrl()) {
      <img
        #previewImage
        class="event-playback-host__preview-video"
        [src]="activeAlarmClipFrameUrl()"
        [attr.alt]="'Alarm clip for ' + (headerTitle() || 'camera')"
        (load)="onAlarmClipImageLoaded($event)"
        (error)="onAlarmClipImageError()"
      />
    } @else if (previewVideoUrl() && (!useLibraryTimeline() || previewUsesWhep())) {
      <video
        #previewVideo
        class="event-playback-host__preview-video"
        [class.event-playback-host__preview-video--library]="useLibraryTimeline()"
        [style.top.px]="useLibraryTimeline() ? videoStageBounds().top : null"
        [style.left.px]="useLibraryTimeline() ? videoStageBounds().left : null"
        [style.width.px]="
          useLibraryTimeline() && videoStageBounds().width > 0 ? videoStageBounds().width : null
        "
        [style.height.px]="
          useLibraryTimeline() && videoStageBounds().height > 0 ? videoStageBounds().height : null
        "
        [attr.src]="previewUsesWhep() ? null : previewVideoUrl()"
        [attr.aria-label]="'Playback preview for ' + (headerTitle() || 'camera')"
        muted
        playsinline
        autoplay
        (loadedmetadata)="onPreviewLoaded($event)"
        (play)="onPreviewPlay()"
        (playing)="onPreviewPlaying()"
        (pause)="onPreviewPause()"
        (timeupdate)="onPreviewTimeUpdate($event)"
      ></video>
    }

    @if (pausedFrameUrl()) {
      <img
        class="event-playback-host__preview-video event-playback-host__preview-frame"
        [class.event-playback-host__preview-video--library]="useLibraryTimeline()"
        [style.top.px]="useLibraryTimeline() ? videoStageBounds().top : null"
        [style.left.px]="useLibraryTimeline() ? videoStageBounds().left : null"
        [style.width.px]="
          useLibraryTimeline() && videoStageBounds().width > 0 ? videoStageBounds().width : null
        "
        [style.height.px]="
          useLibraryTimeline() && videoStageBounds().height > 0 ? videoStageBounds().height : null
        "
        [src]="pausedFrameUrl()"
        [attr.alt]="'Paused frame for ' + (headerTitle() || 'camera')"
      />
    }

    @if (alarmClipImagesLoading()) {
      <div
        class="event-playback-host__stream-loader"
        role="status"
        aria-live="polite"
      >
        <img
          class="event-playback-host__stream-loader-emblem"
          [src]="'assets/events/ecam-emblem.svg' | prefixUrl"
          alt=""
        />
        <span class="event-playback-host__stream-loader-label">Loading alarm images…</span>
      </div>
    } @else if (previewStreamConnecting()) {
      <div
        class="event-playback-host__stream-loader"
        [class.event-playback-host__stream-loader--library]="useLibraryTimeline()"
        [style.top.px]="useLibraryTimeline() ? videoStageBounds().top : null"
        [style.left.px]="useLibraryTimeline() ? videoStageBounds().left : null"
        [style.width.px]="
          useLibraryTimeline() && videoStageBounds().width > 0 ? videoStageBounds().width : null
        "
        [style.height.px]="
          useLibraryTimeline() && videoStageBounds().height > 0 ? videoStageBounds().height : null
        "
        role="status"
        aria-live="polite"
      >
        <img
          class="event-playback-host__stream-loader-emblem"
          [src]="'assets/events/ecam-emblem.svg' | prefixUrl"
          alt=""
        />
        <span class="event-playback-host__stream-loader-label">Connecting stream…</span>
      </div>
    } @else if (previewStreamUnavailable()) {
      <div
        class="event-playback-host__stream-loader event-playback-host__stream-loader--unavailable"
        role="status"
        aria-live="polite"
      >
        <span class="event-playback-host__stream-loader-label">No recording at this time</span>
      </div>
    }

    <lib-playback-page
      class="event-playback-host__library"
      [class.event-playback-host__library--background]="!!previewVideoUrl() && previewUsesWhep()"
      [siteListActive]="false"
      [cameraList]="cameraList"
      [motionOptions]="motionOptions"
      [updateSelectedCameras$]="updateSelectedCameras$"
      [fullScreenLib$]="fullScreenLib$"
      maximumViewPortWidth="100%"
      (requestSegments)="onRequestSegments($event)"
      (OnDownloadSegmentRequested)="onDownload($event)"
    />

    @if (useLibraryTimeline()) {
      <div class="event-playback-host__library-chrome" aria-label="Playback timeline controls">
        <div class="event-playback-host__library-chrome-left">
          <button
            type="button"
            class="event-playback-host__library-chrome-speed"
            [attr.aria-label]="'Playback speed ' + librarySpeedLabel() + ', tap for next speed'"
            (click)="onLibrarySpeedStep()"
          >
            <img
              class="event-playback-host__library-chrome-speed-icon"
              [src]="'assets/library-icons/motion_photos_on.svg' | prefixUrl"
              alt=""
            />
            <span>{{ librarySpeedLabel() }}</span>
          </button>
        </div>

        <div class="event-playback-host__library-chrome-center">
          <eventq-datetime-picker
            class="event-playback-host__library-chrome-datetime"
            mode="field"
            fieldLabel="Center time"
            panelPlacement="above"
            panelAlign="start"
            [showSeconds]="true"
            [value]="libraryCenterDateForPicker()"
            [max]="pickerMaxDate()"
            [timeZoneAbbreviation]="libraryPickerTimeZoneAbbreviation()"
            (applied)="onLibraryCenterDateApply($event)"
          />
        </div>

        <div class="event-playback-host__library-chrome-right">
          <eventq-select
            class="event-playback-host__library-chrome-ai"
            density="compact"
            triggerLabel="AI Events"
            placeholder="AI Events"
            menuPlacement="top-end"
            menuWidth="content"
            [bareTrigger]="true"
            [hideChevron]="true"
            [multiple]="true"
            [badgeCount]="libraryAiEventValues().length"
            [options]="libraryAiEventOptions"
            [values]="libraryAiEventValues()"
            (valuesChange)="onLibraryAiEventsChange($event)"
          />
        </div>
      </div>
    }

    @if (mode() === 'playback' && !showAlarmClipUnavailable()) {
      <div
        class="event-playback-host__detection-layer"
        [class.event-playback-host__detection-layer--bound]="useLibraryTimeline()"
        [style.top.px]="useLibraryTimeline() ? videoStageBounds().top : null"
        [style.left.px]="useLibraryTimeline() ? videoStageBounds().left : null"
        [style.width.px]="useLibraryTimeline() ? videoStageBounds().width : null"
        [style.height.px]="useLibraryTimeline() ? videoStageBounds().height : null"
      >
        <eventq-detection-overlay
          [boxes]="overlayDetectionBoxes()"
          [visibleTypes]="visibleDetectionTypes()"
          [activeOffsetSeconds]="detectionOverlayOffsetSeconds()"
          [videoLayout]="detectionVideoLayout()"
          [animated]="alarmClipBoxesAnimated()"
          [clickable]="aiFeedbackEnabled()"
          (boxClick)="onDetectionBoxClick($event)"
        />

        @if (aiFeedbackEnabled() && showAiFeedbackPopover()) {
          <eventq-ai-feedback-popover
            [open]="true"
            [variant]="aiFeedbackVariant()"
            [detectionId]="aiFeedbackDetectionId()"
            [submitDisabled]="submittingAiFeedback()"
            [anchor]="aiFeedbackAnchor()"
            placement="anchor-right"
            panelWidth="280px"
            (closed)="onAiFeedbackClose()"
            (confirm)="onAiFeedbackConfirm($event)"
          />
        }
      </div>
    }

    @if (mode() === 'live' && showPtzToggle() && ptzControlsOpen()) {
      <eventq-ptz-controls
        class="event-playback-host__ptz"
        (command)="onPtzCommand($event)"
      />
    }
  </div>

  @if (mode() === 'playback' && !useLibraryTimeline()) {
    <div
      class="event-playback-host__footer"
      [class.event-playback-host__footer--compact]="isWebrtcPlaybackTile()"
    >
      <eventq-mini-playback-controls
        [elapsedLabel]="previewElapsedLabel()"
        [durationLabel]="playbackDurationLabel()"
        [progress]="previewProgress()"
        [playing]="previewPlaying()"
        [disabled]="transportDisabled()"
        [showSkip]="effectivePlaybackViewMode() !== 'clip'"
        [skipSeconds]="skipSeconds"
        (playToggle)="onTogglePreviewPlay()"
        (seek)="onPreviewSeek($event)"
        (skipBackward)="onMiniSkip(-skipSeconds)"
        (skipForward)="onMiniSkip(skipSeconds)"
      />
      @if (isWebrtcPlaybackTile() && showPlaybackDatetimePicker()) {
        <eventq-datetime-picker
          class="event-playback-host__footer-datetime"
          mode="field"
          fieldLabel="Playback time"
          panelPlacement="above"
          panelAlign="end"
          [showSeconds]="true"
          [value]="webrtcStreamStartDateForPicker()"
          [max]="pickerMaxDate()"
          [timeZoneAbbreviation]="webrtcPickerTimeZoneAbbreviation()"
          (applied)="onWebrtcStartApply($event)"
        />
      } @else if (effectivePlaybackViewMode() === 'playback' && showPlaybackDatetimePicker()) {
        <eventq-datetime-picker
          mode="field"
          fieldLabel="Playback time"
          [value]="playbackAnchorDateForPicker()"
          [max]="pickerMaxDate()"
          [timeZoneAbbreviation]="playbackAnchorTimeZoneAbbreviation()"
          (applied)="onPlaybackAnchorApply($event)"
        />
      }
    </div>
  }
</div>
